module.exports = __webpack_public_path__ + "easeScaleIn.gif";